import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { ChevronLeft, ChevronRight, Info, X } from "lucide-react";
import { format, startOfWeek, addDays, isToday, addMinutes } from "date-fns";
import { enUS } from "date-fns/locale";
import { getData } from "../../../api/api";
import { CreateSchedule, DeleteSchedule, GetAllRooms, UpdateSchedule } from "../../../api/MonkService";
import { Button, DatePicker, Form, Input, List, notification, Select, Typography, Modal, Popover } from "antd";
import { CreateGroupSchedule, DeleteGroupSchedule, GetAllGroupSchedules, GetGroupsBySize, GetretreatByID, GetRetreatLessons, UpdateGroupSchedule } from "../../../api/AdminService";
import { Option } from "antd/es/mentions"
import {
  MoreOutlined
} from '@ant-design/icons';
import LoadingPage from "../../../Components/LoadingPage/LoadingPage";
export default function MonkWeeklySchedule() {
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [CreateNewActivity, serCreateNewActivity] = useState(null);
  const [duration, setDuration] = useState();
  const [scheduleData, setScheduleData] = useState(null);
  const [retreatLessons, setRetreatLessons] = useState();
  const [LockDay, setLockDay] = useState();
  const [startDate, setstartDate] = useState();
  const [ScheduleID, setScheduleID] = useState();
  const [GroupShceduleID, setGroupShceduleID] = useState();
  const [rooms, setRoom] = useState();
  const [groups, setGroup] = useState();
  const [GroupShcedule, setGroupShcedule] = useState([]);
  const [form] = Form.useForm()
  const { id } = useParams();
  const [Edit, setEdit] = useState(false);
  const [CreateGroup, setCreateGroup] = useState(false);
  const [UpdateGroup, setUpdateGroup] = useState(false);
  const [open, setOpen] = useState(false);
  //detail
  const openActivityDetails = (activity) => {
    setSelectedActivity(activity);
    console.log(activity)
    form.setFieldsValue({
      usedRoomId: activity?.roomID,
      lessonDate: activity?.date,
      lessonStart: activity?.startTime,
      retreatLessionId: activity?.name

    });
    setScheduleID(activity.id);
    getGroupSchedules(activity.id);
  };

  const closeActivityDetails = () => {
    setSelectedActivity(null);
    form.resetFields();
    setEdit(false);
    setCreateGroup(false);
    setUpdateGroup(false);
    setGroupShcedule([]);
  };

  //create
  const OpenNewActivity = (activity) => {
    serCreateNewActivity(activity);
    console.log(activity);
    form.setFieldsValue({
      lessonDate: activity?.date,
      lessonStart: activity?.time
    });
  };

  const CloseNewActivity = () => {
    serCreateNewActivity(null);
    form.resetFields();
  };
  //getGroup
  const getGroups = () => {
    try {
      GetGroupsBySize(id, 1000).then(res => {
        if (res.status === 200) {
          console.log(res.data.data)
          setGroup(res.data.data)
        }
      })
    } catch (err) {
      console.log(err)
    }
  }



  //get Lesson for retreat
  const RetreatLessons = (id) => {
    GetRetreatLessons(id).then(res => {
      if (res.status === 200) {
        console.log(res.data.data)
        setRetreatLessons(res.data.data);
      }
    })
  }

  const GetRetreatID = (id) => {
    GetretreatByID(id).then(res => {
      if (res.status === 200) {
        console.log(res.data)
        setstartDate(new Date(res.data.startDate))
        setLockDay(res.data.startDate)
        setDuration(res.data.duration)
      }
    })
  }

  useEffect(() => {
    RetreatLessons(id);
    GetRetreatID(id);
    getGroups()
  }, []);
  //Get Room

  const getGroupSchedules = (id) => {
    try {
      GetAllGroupSchedules(1000, id).then(res => {
        if (res.status === 200) {
          console.log(res.data.data)
          setGroupShcedule(res.data.data);
        }
      })
    } catch (err) {
      console.log(err)
    }
  }

  //Get Room

  const getRooms = () => {
    try {
      GetAllRooms().then(res => {
        if (res.status === 200) {
          const filteredRooms = res.data.data.filter(room => room.roomType.name !== "Bed room");
          console.log(filteredRooms);
          setRoom(filteredRooms);
        }
      })
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getRooms();
  }, []);

  //onFinish
  const onFinish = async (values) => {
    console.log('value :', values);
    const [hour, minute] = values.lessonStart.split(':').map(Number);
    const lessonEndHour = (hour + 1) % 24; // Add 1 hour and wrap around if it exceeds 23
    const lessonEnd = `${lessonEndHour}:${minute.toString().padStart(2, '0')}`; // Keep the minutes the same
    CreateSchedule(
      id,
      values.retreatLessionId,
      values.usedRoomId,
      values.lessonDate,
      values.lessonStart,
      lessonEnd
    ).then((res) => {
      console.log(res);
      notification.success({
        message: "Success creating activity"
      });
      window.location.reload();

    }).catch(err => {
      console.log(err.response)
      notification.error({
        message: `${err.response.data.message}`
      })
    });
  }

  const onFinishUpdate = async (values) => {
    console.log('value :', values);
    const [hour, minute] = values.lessonStart.split(':').map(Number);
    const lessonEndHour = (hour + 1) % 24; // Add 1 hour and wrap around if it exceeds 23
    const lessonEnd = `${lessonEndHour}:${minute.toString().padStart(2, '0')}`; // Keep the minutes the same
    UpdateSchedule(
      ScheduleID,
      values.retreatLessionId,
      values.usedRoomId,
      values.lessonDate,
      values.lessonStart,
      lessonEnd
    ).then((res) => {
      console.log(res);
      notification.success({
        message: "Success update activity"
      });
      window.location.reload();

    }).catch(err => {
      console.log(err.response)
      notification.error({
        message: `${err.response.data.message}`
      })
    });
  }

  const onFinishCreateGroupSchedule = async (values) => {
    console.log('value :', values);
    const formData = new FormData();
    formData.append('retreatScheduleId', ScheduleID);
    formData.append('groupId', values.groupId);
    formData.append('roomName', values.roomName);
    CreateGroupSchedule(
      formData
    ).then((res) => {
      console.log(res);
      notification.success({
        message: "Create Group Successfully"
      });
      getGroupSchedules(ScheduleID)
      form.resetFields();
      setCreateGroup(false)
    }).catch(err => {
      console.log(err.response)
      notification.error({
        message: `${err.response.data.message}`
      })
    });
  }

  const onFinishUpdateGroupSchedule = async (values) => {
    const formData = new FormData();
    formData.append('retreatScheduleId', ScheduleID);
    formData.append('roomName', values.roomName);

    // Check the data in formData
    formData.forEach((value, key) => {
      console.log(`${key}: ${value}`);
    });

    UpdateGroupSchedule(
      GroupShceduleID, formData
    ).then((res) => {
      console.log(res);
      notification.success({
        message: "Uppdate Group Successfully"
      });
      getGroupSchedules(ScheduleID)
      setUpdateGroup(false)

    }).catch(err => {
      console.log(err.response)
      notification.error({
        message: `${err.response.data.message}`
      })
    });
  }


  const deleteActivity = (id) => {
    DeleteSchedule(id).then((res) => {
      console.log(res)
      notification.success({
        message: "Delete Successfully"
      });
      window.location.reload();
    }).catch(err => {
      console.log(err.response)
      notification.error({
        message: `${err.response.data.message}`
      })
    });
  }



  const startOfCurrentWeek = startOfWeek(startDate, { weekStartsOn: 1 });
  const days = Array.from({ length: 7 }, (_, i) =>
    addDays(startOfCurrentWeek, i)
  );

  // Generate time slots from startTime to endTime at every 3 hours
  const generateTimeSlots = (startTime, endTime, interval) => {
    const start = new Date(`1970-01-01T${startTime}:00`);
    const end = new Date(`1970-01-01T${endTime}:00`);
    const times = [];

    for (let time = start; time < end; time = addMinutes(time, interval)) {
      times.push(format(time, "HH:mm"));
    }

    return times;
  };

  // Define the time slots
  const timeSlots = generateTimeSlots("06:00", "21:00", 180); // From 06:00 to 21:00 every 3 hours

  useEffect(() => {
    getData(`schedule/retreat/${id}`).then((data) => {
      const scheduleItems = data.data.data;
      const activities = [];

      scheduleItems.forEach((item) => {
        const startTime = item.lessonStart.substring(0, 5); // "09:45"
        const endTime = item.lessonEnd ? item.lessonEnd.substring(0, 5) : "";
        const date = item.lessonDate; // "2024-11-18"

        activities.push({
          id: item.id,
          startTime: startTime,
          endTime: endTime,
          date: date, // Use date string
          name: item.lessonTitle,
          details: item.lessonContent,
          location: item.usedRoom ? item.usedRoom.name : "",
          roomID: item.usedRoom ? item.usedRoom.id : "",
        });
      });

      setScheduleData({
        timeSlots,
        activities,
      });
    });
  }, [startDate, id]);

  const handleDelete = (id) => {
    DeleteGroupSchedule(id).then((res) => {
      console.log(res)
      notification.success({
        message: "Delete Successfully"
      });
      getGroupSchedules(ScheduleID)
    }).catch(err => {
      console.log(err.response)
      notification.error({
        message: `${err.response.data.message}`
      })
    });
  };

  if (!scheduleData) {
    return <LoadingPage/>;
  }

  return (
    <div className="h-[96.5vh] bg-[#f9f7f4]">
      <div className="max-w-[1200px] mx-auto p-4">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-xl font-medium text-[#725b53]">
            Basic Schedule for the Retreat Week from{" "}
            {format(startOfCurrentWeek, "yyyy-MM-dd")} to {" "}
            {format(addDays(startOfCurrentWeek, 6), "yyyy-MM-dd")}
          </h1>
          <div className="flex items-center gap-2">
            <button
              className="p-2 hover:bg-gray-200 rounded"
              onClick={() => setstartDate(addDays(startDate, -7))}
            >
              <ChevronLeft className="w-5 h-5 text-gray-600" />
            </button>
            <button
              className="p-2 hover:bg-gray-200 rounded"
              onClick={() => {
                const newDate = addDays(startDate, 7);
                const maxDate = addDays(LockDay, (7 * duration));
                if (newDate <= maxDate) {
                  setstartDate(newDate);
                }
              }}
            >
              <ChevronRight className="w-5 h-5 text-gray-600" />
            </button>
          </div>
        </div>

        {/* Schedule Grid */}
        <div className="overflow-x-auto">
          <div className="min-w-[900px]">
            {/* Days Header */}
            <div className="grid grid-cols-[150px_repeat(7,1fr)] bg-[#e8e1d9]">
              <div className="p-2 font-medium text-[#725b53] border-r border-[#d3c7bc]">
                Time
              </div>
              {days.map((day, index) => {
                const dayName = format(day, "EEEE", { locale: enUS });
                const dayNumber = format(day, "yyyy-MM-dd");
                const isTodayFlag = isToday(day);
                return (
                  <div
                    key={index}
                    className={`p-2 font-medium text-center text-[#725b53] border-r border-[#d3c7bc] ${isTodayFlag ? "bg-yellow-200" : ""
                      }`}
                  >
                    <span>{dayName}</span>
                    <div>{dayNumber}</div>
                  </div>
                );
              })}
            </div>

            {/* Time Slots */}
            {scheduleData.timeSlots.map((time) => {
              // For each time slot, calculate start and end minutes
              const [slotHour, slotMinute] = time.split(":").map(Number);
              const timeSlotStartMinutes = slotHour * 60 + slotMinute;
              const timeSlotEndMinutes = timeSlotStartMinutes + 180; // 3 hours
              const timeSlotEndTime = format(
                addMinutes(new Date(`1970-01-01T${time}:00`), 180),
                "HH:mm"
              );

              return (
                <div
                  key={time}
                  className="grid grid-cols-[150px_repeat(7,1fr)] border-b border-[#d3c7bc]"
                >
                  <div className="p-2 text-sm text-[#725b53] border-r border-[#d3c7bc] bg-[#f3efe9]">
                    {time} - {timeSlotEndTime}
                  </div>
                  {days.map((day, index) => {
                    const dateStr = format(day, "yyyy-MM-dd");
                    const isBeforeStartDate = day < new Date(LockDay).setDate(new Date(LockDay).getDate() - 1);
                    const isAfterEndDate = day > addDays(new Date(LockDay), duration)
                    const activitiesInTimeSlot = scheduleData.activities.filter(
                      (activity) => {
                        if (activity.date !== dateStr) {
                          return false;
                        }
                        const [activityHour, activityMinute] = activity.startTime
                          .split(":")
                          .map(Number);
                        const activityStartMinutes =
                          activityHour * 60 + activityMinute;
                        return (
                          activityStartMinutes >= timeSlotStartMinutes &&
                          activityStartMinutes < timeSlotEndMinutes
                        );
                      }
                    );
                    const isTodayFlag = isToday(day);

                    return (
                      <div
                        key={`${dateStr}-${time}`}
                        className={`p-2 text-sm border-r border-[#d3c7bc] min-h-[60px] ${isTodayFlag ? "bg-yellow-200" : ""} ${isBeforeStartDate || isAfterEndDate ? "bg-gray-300 opacity-50 cursor-not-allowed" : ""}`}
                        onClick={() => !isBeforeStartDate && !isAfterEndDate && activitiesInTimeSlot.length === 0 && OpenNewActivity({ date: dateStr, time })}
                      >
                        {activitiesInTimeSlot.length === 0 ? (
                          <div />
                        ) : (
                          activitiesInTimeSlot.map((activity) => (
                            <button
                              key={activity.id}
                              onClick={() => openActivityDetails(activity)}
                              className="hover:bg-[#e8e1d9]"
                            >
                              <div className="flex items-start gap-2 w-full text-left hover:bg-[#e8e1d9] p-1 rounded transition-colors">
                                <span className="flex-1">{activity.name}</span>
                                <Info className="w-4 h-4 text-gray-400 flex-shrink-0" />
                              </div>
                              <div className="text-start">{activity.startTime}</div>
                            </button>
                          ))
                        )}
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
          {/* <div style={{ marginTop: 16 }}>
            <Button type="primary" onClick={() => setOpen(true)}>Create Activity</Button>
          </div> */}
        </div>

        {/* Activity Details Popup */}
        {Edit && !CreateGroup && !UpdateGroup ? (
          <>
            {selectedActivity && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
                <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full">
                  <div className="flex justify-between items-start mb-4">
                    <h2 className="text-xl font-semibold text-[#725b53]">
                      {selectedActivity.name}
                    </h2>
                    <button
                      onClick={closeActivityDetails}
                      className="text-gray-500 hover:text-gray-700"
                    >
                      <X className="w-6 h-6" />
                    </button>
                  </div>
                  <div className="space-y-2 text-[#725b53]">
                    <Form form={form} onFinish={onFinishUpdate}>
                      <Form.Item name={"retreatLessionId"} label="Lesson" rules={[{ required: true, message: 'Requiring lesson' }]}>
                        <Select placeholder="Choose Lesson">
                          {retreatLessons.map((item) => (
                            <Option key={item.id} value={item.id}>
                              {item.lessonTitle}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                      <Form.Item name={"lessonDate"} label="Lesson Date" rules={[{ required: true, message: 'Requiring date' }]}>
                        <Input
                          type="date"
                          style={{
                            color: 'rgba(0, 0, 0, 0.88)',
                          }}
                          placeholder="YYYY-MM-DD"
                        />
                      </Form.Item>
                      <Form.Item name={"lessonStart"} label="Lesson Start" rules={[{ required: true, message: 'Requiring time' }]}>
                        <Select placeholder="Choose Time">
                          <Option value="06:00">6:00</Option>
                          <Option value="09:00">9:00</Option>
                          <Option value="12:00">12:00</Option>
                          <Option value="15:00">15:00</Option>
                          <Option value="18:00">18:00</Option>
                        </Select>
                      </Form.Item>
                      <Form.Item>
                        <Button block type="primary" htmlType="submit">
                          Confirm Update
                        </Button>
                      </Form.Item>
                    </Form>
                  </div>
                </div>
              </div>
            )}
          </>
        ) : CreateGroup && !UpdateGroup ? (
          <>
            {selectedActivity && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
                <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full">
                  <div className="flex justify-between items-start mb-4">
                    <h2 className="text-xl font-semibold text-[#725b53]">
                      Add Group
                    </h2>
                    <button
                      onClick={closeActivityDetails}
                      className="text-gray-500 hover:text-gray-700"
                    >
                      <X className="w-6 h-6" />
                    </button>
                  </div>
                  <div className="space-y-2 text-[#725b53]">
                    <Form form={form}
                      onFinish={onFinishCreateGroupSchedule}
                    >
                      <Form.Item name={"groupId"} label="Group" rules={[{ required: true, message: 'Requiring Group' }]}>
                        <Select
                          placeholder="Choose Group"
                        >
                          {groups.map((item) => (
                            <Option key={item.id} value={item.id} >
                              {item.name}
                            </Option>
                          ))}

                        </Select>
                      </Form.Item>
                      <Form.Item name={"roomName"} label="Room" rules={[{ required: true, message: 'Requiring Room' }]}>
                        <Select
                          placeholder="Choose Room"
                        >
                          {rooms.map((item) => (
                            <Option key={item.id} value={item.name} >
                              {item.name}
                            </Option>
                          ))}

                        </Select>
                      </Form.Item>



                      <Form.Item>
                        <Button block type="primary" htmlType="submit">
                          Save
                        </Button>
                      </Form.Item>
                    </Form>
                  </div>
                </div>
              </div>
            )}
          </>
        ) : UpdateGroup ? (
          <>
            {selectedActivity && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
                <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full">
                  <div className="flex justify-between items-start mb-4">
                    <h2 className="text-xl font-semibold text-[#725b53]">
                      Update Group
                    </h2>
                    <button
                      onClick={closeActivityDetails}
                      className="text-gray-500 hover:text-gray-700"
                    >
                      <X className="w-6 h-6" />
                    </button>
                  </div>
                  <div className="space-y-2 text-[#725b53]">
                    <Form form={form}
                      onFinish={onFinishUpdateGroupSchedule}
                    >
                      <Form.Item name={"roomName"} label="Room" rules={[{ required: true, message: 'Requiring Room' }]}>
                        <Select
                          placeholder="Choose Room"
                        >
                          {rooms.map((item) => (
                            <Option key={item.id} value={item.name} >
                              {item.name}
                            </Option>
                          ))}

                        </Select>
                      </Form.Item>

                      <Form.Item>
                        <Button block type="primary" htmlType="submit">
                          Save
                        </Button>
                      </Form.Item>
                    </Form>
                  </div>
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            {selectedActivity && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
                <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full">
                  <div className="flex justify-between items-start mb-4">
                    <h2 className="text-xl font-semibold text-[#725b53]">
                      {selectedActivity.name}
                    </h2>
                    <button
                      onClick={closeActivityDetails}
                      className="text-gray-500 hover:text-gray-700"
                    >
                      <X className="w-6 h-6" />
                    </button>
                  </div>
                  <div className="space-y-2 text-[#725b53]">
                    <p>
                      <strong>Start Time:</strong> {selectedActivity.startTime}
                    </p>
                    <p>
                      <strong>End Time:</strong> {selectedActivity.endTime}
                    </p>
                    <p>
                      <strong>Date:</strong>{" "}
                      {format(new Date(selectedActivity.date), "EEEE, dd.MM.yyyy", {
                        locale: enUS,
                      })}
                    </p>
                    <p>
                      <strong>Details:</strong> {selectedActivity.details}
                    </p>
                    {!(GroupShcedule.length > 0) ? (<></>) : (
                      <List
                        dataSource={Array.isArray(GroupShcedule) ? GroupShcedule : []}
                        renderItem={(item) => (
                          <List.Item
                            actions={[
                              <Popover
                                content={
                                  <div>
                                    <Button onClick={() => {
                                      setUpdateGroup(true);
                                      setGroupShceduleID(item.id);
                                    }} style={{ marginRight: 8 }}>
                                      Edit
                                    </Button>
                                    <Button
                                      onClick={() => handleDelete(item.id)}
                                    >
                                      Delete
                                    </Button>
                                  </div>
                                }
                                trigger="click"
                                placement="bottom"
                              >
                                <MoreOutlined />
                              </Popover>
                            ]}
                          >
                            <div style={{ width: '100%' }}>
                              <div>
                                <Typography.Text>{`Group: ${item.groupName}`}</Typography.Text>
                              </div>
                              <div>
                                <Typography.Text>{`Room: ${item.roomName}`}</Typography.Text>
                              </div>
                            </div>
                          </List.Item>
                        )}
                        bordered
                        style={{
                          backgroundColor: '#fafafa',
                          borderRadius: '6px',
                        }}
                      />
                    )}

                    <Button
                      onClick={() => setEdit(true)}
                      className="text-blue-500 hover:text-blue-700"
                      style={{ marginRight: 50 }}
                    >
                      Update
                    </Button>
                    <Button
                      onClick={() => setCreateGroup(true)}
                      className="text-blue-500 hover:text-blue-700"
                      style={{ marginRight: 50 }}
                    >
                      Add Group
                    </Button>
                    <Button
                      onClick={() => deleteActivity(selectedActivity.id)}
                      className="text-red-500 hover:text-red-700"
                    >
                      Delete
                    </Button> 
                  </div>
                </div>
              </div>
            )}
          </>
        )}

        {CreateNewActivity && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full">
              <div className="flex justify-between items-start mb-4">
                <h2 className="text-xl font-semibold text-[#725b53]">
                  Create New Activity
                </h2>
                <button
                  onClick={CloseNewActivity}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>
              <div className="space-y-2 text-[#725b53]">
                <Form
                  form={form}
                  onFinish={onFinish}
                >
                  <Form.Item name={"retreatLessionId"} label="Lesson" rules={[{ required: true, message: 'Requiring lesson' }]}>
                    <Select
                      placeholder="Choose Lesson"
                    >
                      {retreatLessons.map((item) => (
                        <Option key={item.id} value={item.id} >
                          {item.lessonTitle}
                        </Option>
                      ))}

                    </Select>
                  </Form.Item>
                  {/* <Form.Item name={"usedRoomId"} label="Room" rules={[{ required: true, message: 'Requiring Room' }]}>
                  <Select
                    placeholder="Choose Room"
                  >
                    {rooms.map((item) => (
                      <Option key={item.id} value={item.id} >
                        {item.name}
                      </Option>
                    ))}

                  </Select>
                </Form.Item> */}
                  <Form.Item name={"lessonDate"} label="Lesson Date" rules={[{ required: true, message: 'Requiring date' }]}>
                    <Input disabled
                      style={{
                        color: 'rgba(0, 0, 0, 0.88)',
                      }}
                    />
                  </Form.Item>
                  <Form.Item name={"lessonStart"} label="Lesson Start" rules={[{ required: true, message: 'Requiring time' }]}>
                    <Input disabled
                      style={{
                        color: 'rgba(0, 0, 0, 0.88)',
                      }}
                    />
                  </Form.Item>
                  <Form.Item>
                    <Button block type="primary" htmlType="submit">
                      Save
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </div>

          </div>
        )}



        {/* <Modal
          title={<div style={{ fontSize: 20 }}>Create New Activity</div>}
          centered
          open={open}
          onCancel={() => setOpen(false)}
          footer={null}
        >
          <div className="space-y-2 text-[#725b53]">
            <Form
              form={form}
              onFinish={onFinish}
            >
              <Form.Item name={"retreatLessionId"} label="Lesson" rules={[{ required: true, message: 'Requiring lesson' }]}>
                <Select
                  placeholder="Choose Lesson"
                >
                  {retreatLessons.map((item) => (
                    <Option key={item.id} value={item.id} >
                      {item.lessonTitle}
                    </Option>
                  ))}

                </Select>
              </Form.Item>
              <Form.Item name={"lessonDate"} label="Lesson Date" 
              rules={[{ required: true, 
                        message: 'Requiring date',
                        validator: (_, value) => {
                          const regex = /^\d{4}-\d{2}-\d{2}$/; // Regex for YYYY-MM-DD format
                          if (!value || regex.test(value)) {
                              return Promise.resolve();
                          }
                          return Promise.reject(new Error('Date must be in YYYY-MM-DD format'));
                      } }]}>
                <Input placeholder="YYYY-MM-DD"/>
              </Form.Item>
              <Form.Item name={"lessonStart"} label="Lesson Start" rules={[{ required: true, message: 'Requiring time' }]}>
                <Select placeholder="Choose Time">
                  <Option value="06:00">6:00</Option>
                  <Option value="09:00">9:00</Option>
                  <Option value="12:00">12:00</Option>
                  <Option value="15:00">15:00</Option>
                  <Option value="18:00">18:00</Option>
                </Select>
              </Form.Item>
              <Form.Item>
                <Button block type="primary" htmlType="submit">
                  Save
                </Button>
              </Form.Item>
            </Form>
          </div>
        </Modal> */}

      </div>
    </div>
  );
}
